<style lang="scss" scoped>
h1 {
  color: rgb(24, 174, 194);
  margin: 15px 0;
}
h3 {
  font-size: 20px;
}
p {
  font-weight: bold;
  font-size: 19px;
}
.info {
  font-size: 27px;
  font-weight: lighter;
  color: #fff;
  padding: 8px 10px;
  text-indent: 30px;
}
.info-col {
  background-color: rgb(24, 174, 194);
}
.col-12 {
  padding-left: 0;
}
//Адаптив
@media (min-width: 576px) and (max-width: 767.98px) {
  .info {
    text-align: justify;
    padding: 15px 5px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .info {
    padding: 15px 10px;
    font-size: 17px;
  }
}
@media (max-width: 370px) {
  h1 {
    font-size: 20px;
  }
}
</style>
<template>
  <div class="Electrician">
    <b-container>
      <b-row>
        <b-col cols="12">
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-col>
        <b-col cols="12">
          <h1>
            Электромонтер по ремонту и обслуживанию электрооборудования
          </h1>
        </b-col>
        <b-col cols="12">
          <h3>
            Квалификация: <em>электромонтер по ремонту и обслуживанию электрооборудования</em>
          </h3>
        </b-col>
        <b-col class="mb-3 info-col" cols="12" lg="6" xl="7">
          <p class="info">
            <em>
              Электромонтер по ремонту и обслуживанию  электрооборудования - рабочая профессия, 
              востребованная как в быту, так и в промышленности. Это вызвано необходимостью использования 
              всевозможных электрических устройств для обеспечения комфортного быта и эффективного 
              выполнения рабочих задач.
            </em>
          </p>
        </b-col>
        <b-col class="mb-3 d-none d-lg-block" cols="6" xl="5">
          <img class="img-fluid" src="../assets/img/others/electrician.jpg" alt="Информационные системы">
        </b-col>
        <b-col cols="12">
          <p>
            Срок обучения 1 года 10 месяцев (на базе 9 классов). Форма обучения очная.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col cols="12">
          <b-tabs justified>
            <b-tab title="Необходимые навыки и знания для обучения на программе" active>
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/book.png" alt="apple">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                    Базовые знания физики и математики; <br>
                    Математическое  и логическое мышление; <br>
                    Пространственно-образное мышление; <br>
                    Расчетно-вычислительные навыки; <br>
                    Базовые навыки работы с чертежами и схемами; <br>
                    Базовые технические навыки; <br>
                    Навыки простых экспериментальных исследований; <br>
                    Навыки безопасного использования электрических приборов; <br>
                    Гибкость и координация движения кистей и пальцев рук.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Что предстоит изучить">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/teatcher.png" alt="">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                      Электротехнику. Контрольно-измерительные приборы. Сборка, монтаж, регулировка и ремонт узлов 
                      и механизмов оборудования, агрегатов, машин, станков и другого электрооборудования 
                      промышленных организаций. Проверка и наладка электрооборудования. Устранение и 
                      предупреждение аварий и неполадок электрооборудования. Охрана труда. Электротехника. 
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Профессиональная деятельность">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="2" offset="1">
                    <img class="img-fluid" src="../assets/img/others/specialist.png" alt="athom">
                  </b-col>
                  <b-col cols="12" md="8" offset-md="1">
                    <p>
                      Осуществляет сборку, монтаж, регулировка, ремонт электрооборудования. 
                      Электромонтер выполняет слесарную обработку, пайку деталей и узлов, выявляет и 
                      устраняет дефекты во время эксплуатации оборудования и при проверке его в процессе 
                      ремонта. Осуществляет проверку и наладку электрооборудования, настраивает и регулирует 
                      контрольно-измерительные приборы. Проводит плановые и внеочередные осмотры 
                      электрооборудования, в случае обнаружения неисправности выполняет его замену.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Профессиональные и личные качества">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/partner.png" alt="man">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                      Профессиональные качества: гибкость мышления; наглядно-образное мышление; высокий уровень 
                      концентрации, распределения и устойчивости внимания; хорошая память; пространственное 
                      воображение; способность принимать и внедрять новое на практике; аналитические способности. <br>
                      Личные качества:высокая ответственность и дисциплина; хорошая память; 
                      стрессоустойчивость; коммуникабельность. 
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="Область применения полученных знаний">
              <b-container>
                <b-row class="mt-3 mb-3">
                  <b-col class="d-none d-md-block" cols="3" offset="1">
                    <img class="img-fluid" src="../assets/img/others/home.png" alt="">
                  </b-col>
                  <b-col cols="12" md="7" offset-md="1">
                    <p>
                      Выполнение  работ по ремонту и обслуживанию электрооборудования, монтаж и ремонт 
                      распределительных коробок, клеммников, предохранительных щитков и осветительной арматуры. 
                      Регулирование и проверка нагрузки электрооборудования, аппаратуры и приборов 
                      электроприводов после ремонта. <br>
                      Обслуживание силовых и осветительных электроустановок со сложными схемами включения.  
                      Выявление и устранение неисправностей в работе обслуживаемого оборудования. 
                      Участие в ликвидации аварийных ситуаций на обслуживаемом оборудовании. 
                      Вывод электрооборудования в ремонт и ввод его в работу.
                    </p>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <ElectricianSliderStudents />
    </b-container>
  </div>
</template>

<script>
import ElectricianSliderStudents from "../../src/components/ElectricianSliderStudents";

export default {
  name: "Electrician",
  components: {
    ElectricianSliderStudents
  },
  data() {
      return {
        items: [
          {
            text: 'Специальности',
            href: '/Specialties'
          },
          {
            text: 'Электромонтер по ремонту и обслуживанию электрооборудования',
            active: true
          }
        ]
      }
    }
};
</script>